/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionVatReviewDecisionData
 */
export interface SubscriptionVatReviewDecisionData {
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionVatReviewDecisionData
     */
    chargeVat?: boolean;
}

/**
 * Check if a given object implements the SubscriptionVatReviewDecisionData interface.
 */
export function instanceOfSubscriptionVatReviewDecisionData(value: object): value is SubscriptionVatReviewDecisionData {
    return true;
}

export function SubscriptionVatReviewDecisionDataFromJSON(json: any): SubscriptionVatReviewDecisionData {
    return SubscriptionVatReviewDecisionDataFromJSONTyped(json, false);
}

export function SubscriptionVatReviewDecisionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionVatReviewDecisionData {
    if (json == null) {
        return json;
    }
    return {
        
        'chargeVat': json['chargeVat'] == null ? undefined : json['chargeVat'],
    };
}

export function SubscriptionVatReviewDecisionDataToJSON(json: any): SubscriptionVatReviewDecisionData {
    return SubscriptionVatReviewDecisionDataToJSONTyped(json, false);
}

export function SubscriptionVatReviewDecisionDataToJSONTyped(value?: SubscriptionVatReviewDecisionData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'chargeVat': value['chargeVat'],
    };
}

